export const destroy = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g>
      <g transform="translate(-165 -442)">
        <circle cx="177" cy="454" r="11.36" fill="#e01d1b" />
        <g transform="translate(170.143 447.143)">
          <path d="M1.34 1.34L12.7 12.7" stroke="#ffffff" />
          <path d="M1.34 12.7L12.7 1.34" stroke="#ffffff" />
        </g>
      </g>
    </g>
  </svg>
);
